module.exports = __webpack_public_path__ + "img/joom.7be402e.svg";